import * as moment from 'moment';
export class DateConstants{

    public static days =  ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
    public static hours = ["09:00 PM", "10:00 PM", "11:00 PM", "12:00 AM", "01:00 AM", "02:00 AM", "03:00 AM"];
    public static firstShift = ["09:00 PM", "10:00 PM","11:00 PM"];
    public static secondShift = ["12:00 AM", "01:00 AM", "02:00 AM", "03:00 AM"];
    public static standardDateFormat = "YYYY-MM-DD";
    public static standardDateTimeFormat = "YYYY-MM-DD hh:mm A";
    public static shortDateTimeFormate = "ddd MMM DD, YYYY hh:mm A"
    public static shortDateTimeFormatNoTime = "ddd MMM DD, YYYY"
    public static shortDateTimeFormat2 = "MMM DD, YYYY hh:mm A"
    public static standard24hHrDateTimeFormat = "YYYY-MM-DD HH:mm";
    public static localizedStandard = "dddd MMM , DD YYYY hh:mm A"
    public static HourMinute12H = "hh:mm A";
    public static HourMinute12HShort =  "hh:mmA";
 
    public static formatDayString(dayString:string){
        return moment(dayString).format('dddd MMM DD');
    }
}